

































































































import TableComp from '@/components/Common/TableComp.vue';
import CommonIconBtn from '@/components/Common/CommonIconBtn.vue';
import { Component, Prop, Vue, Watch, ModelSync } from 'vue-property-decorator';
import {
  setIssueUserSuperiorApi,
  getIssueUserSuperiorApi,
  removeIssueUserSuperiorApi,
} from '@/api/company';

@Component({
  name: 'setBusinessSuperiorDialog',
  components: {
    TableComp,
    CommonIconBtn,
  }
})
export default class extends Vue {
  @Prop() public row!: any;
  @ModelSync('dialogVisibleSetSuperior', 'changeVisible', { type: Boolean }) public dialogVisible!: boolean;

  public selectedTableDatas: any[] = [];
  public unSelectedTableDatas: any[] = [];
  public currentSelectedTableDatas: any[] = [];
  public currentUnSelectedTableDatas: any[] = [];
  public selectedDatas: any[] = [];
  public unSelectedDatas: any[] = [];
  public selectedChecked: boolean = false;
  public unSelectedChecked: boolean = false;
  public fkUserSuperiorId: number = 0;
  public searchSelected: string = '';
  public searchUnSelected: string = '';

  @Watch('dialogVisible')
  public watchVisible(visible: boolean) {
    if (visible) {
      this.getIssueUserSuperior();
    }
  }

  public async getIssueUserSuperior() {
    const { data } = await getIssueUserSuperiorApi(this.row.id);
    this.selectedTableDatas = data.data.isExistDatas;
    this.unSelectedTableDatas = data.data.notExistDatas;
    this.currentUnSelectedTableDatas = data.data.notExistDatas;
    this.currentSelectedTableDatas = data.data.isExistDatas;
    this.fkUserSuperiorId = data.data.fkUserSuperiorId;
  }
  // 搜索
  public handleSearchUnSelected(searchVal: string) {
    if (!this.unSelectedTableDatas || !this.unSelectedTableDatas.length) {
      return;
    }
    if (searchVal) {
      const value = searchVal.trim();
      const array = this.unSelectedTableDatas.filter((item) => {
        const typeName = item.contactPersonTypeName || '';
        return item.name.includes(value) || item.loginId.includes(value) || typeName.includes(value)
      });
      this.currentUnSelectedTableDatas = array;
    } else {
      this.currentUnSelectedTableDatas = this.unSelectedTableDatas;
    }
  }
  // 搜索
  public handleSearchSelected(searchVal: string) {
    if (!this.selectedTableDatas || !this.selectedTableDatas.length) {
      return;
    }
    if (searchVal) {
      const value = searchVal.trim();
      const array = this.selectedTableDatas.filter((item) => {
        const typeName = item.contactPersonTypeName || '';
        return item.name.includes(value) || item.loginId.includes(value) || typeName.includes(value)
      });
      this.currentSelectedTableDatas = array;
    } else {
      this.currentSelectedTableDatas = this.selectedTableDatas;
    }
  }

  public handleSelectedCheckedChange(checked: boolean) {
    const selectedRef: any = this.$refs.selectedRef;
    if (checked) {
      this.selectedTableDatas.forEach((item: any) => {
        selectedRef.getTableRef().toggleRowSelection(item, true);
      });
      this.selectedDatas = this.selectedTableDatas;
    } else {
      selectedRef.getTableRef().clearSelection();
      this.selectedDatas = [];
    }
  }

  public handleUnSelectedCheckedChange(checked: boolean) {
    const unSelectedRef: any = this.$refs.unSelectedRef;
    if (checked) {
      this.unSelectedTableDatas.forEach((item: any) => {
        unSelectedRef.getTableRef().toggleRowSelection(item, true);
      });
      this.unSelectedDatas = this.unSelectedTableDatas;
    } else {
      unSelectedRef.getTableRef().clearSelection();
      this.unSelectedDatas = [];
    }
  }

  public handleUnSelect({ selection }: any) {
    this.unSelectedDatas = selection;
  }

  public handleSelect({ selection }: any) {
    this.selectedDatas = selection;
  }

  public handleRemove() {
    if (!this.selectedDatas.length) {
      this.$message.warning(this.$t('message.removeSuperiorMessage') as string)
      return;
    }
    this.$confirm(this.$t('message.removeSuperiorConfirm', { name: this.row.name }) as string, '', {
      confirmButtonText: this.$t('common.confirm') as string,
      cancelButtonText: this.$t('common.cancel') as string,
      type: 'warning',
    }).then(async () => {
      const params = this.selectedDatas.map((item) => {
        return {
          fkUserSuperiorId: item.id,
          fkUserId: this.row.id,
        }
      })
      await removeIssueUserSuperiorApi(params, this.row.id);
      this.$message.success(this.$t('message.removeSuccess') as string);
      this.getIssueUserSuperior();
    }).catch(() => {
      this.$message.info(this.$t('common.cancelled') as string);
    });
  }

  public handleAppend() {
    if (!this.unSelectedDatas.length) {
      this.$message.warning(this.$t('message.setSuperiorMessage') as string)
      return;
    }
    this.$confirm(this.$t('message.appendSuperiorConfirm', { name: this.row.name }) as string, '', {
      confirmButtonText: this.$t('common.confirm') as string,
      cancelButtonText: this.$t('common.cancel') as string,
      type: 'warning',
    }).then(async () => {
      const params = this.unSelectedDatas.map((item) => {
        return {
          fkUserId: this.row.id,
          fkUserSuperiorId: item.id,
        }
      })
      await setIssueUserSuperiorApi(params, this.row.id);
      this.$message.success(this.$t('message.setSuccess') as string);
      this.getIssueUserSuperior();
    }).catch(() => {
      this.$message.info(this.$t('common.cancelled') as string);
    });
  }
}
